module.exports = __webpack_public_path__ + "assets/images/project/capacity-size/mobile.svg?v=15fbca18";